import RegisteredUserData from "./RegisteredUserData";

class RegisteredUserResponse {
    constructor({ registerList = [] } = {}) {
        this.registerList = registerList;
    }

    static fromJson(json) {
        const registerList = json.response?.registerList?.map(item => RegisteredUserData.fromJson(item)) || [];
        return new RegisteredUserResponse({ registerList });
    }
}
export default RegisteredUserResponse;
